import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { ResultsSection } from './components/ResultsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { IncludesSection } from './components/IncludesSection';
import { PricingSection } from './components/PricingSection';
import { ClosingSection } from './components/ClosingSection';
import { initMetaPixel, trackPageView } from './utils/pixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="w-full min-h-screen bg-cream font-sans" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <ResultsSection data-id="element-5" />
      <ForWhoSection data-id="element-6" />
      <IncludesSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <ClosingSection data-id="element-9" />
    </main>;
}